import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, App } from 'ionic-angular';
import { StaffProvider } from '../../providers/staff/staff';
import { ToastProvider } from '../../providers/toast/toast';
import { StaffDetailPage } from '../staff-detail/staff-detail';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-my-staff',
  templateUrl: 'my-staff.html',
})
export class MyStaffPage {

  staffs: any;
  presentStaff=[];
  absentStaff=[];
  fakeStaffs: Array<any> = new Array(1);
  selRegistrationLogin  : any;



  constructor(public navCtrl: NavController, private translate: TranslateService, public navParams: NavParams, private staffProvider: StaffProvider, private toast: ToastProvider, private app: App) {
    

    this.selRegistrationLogin = localStorage.getItem('signup_login')

    if(this.selRegistrationLogin){
      this.staffs = [];
      this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.");
    }
    else{
    staffProvider.getStaffs().then(val => {
  		if(val.status == "success"){
        this.staffs = val.data;
        this.generateData();
  		}else{
        this.staffs = [];
  			this.toast.presentToast(val.message);
  		}
    });
  }
    
  }

  doRefresh(refresher){
    if(this.selRegistrationLogin){
      setTimeout(() => {
        refresher.complete() 
        },2000)
    }else{
    this.staffProvider.getStaffs().then(val => {
      if(val.status == "success"){
        this.staffs = val.data;
        this.generateData();
      }else{
        this.toast.presentToast(val.message);
      }
      refresher.complete();
    });
  } 
}

  refreshStaff(){
    this.staffs = null;
    this.staffProvider.getStaffs().then(val => {
  		if(val.status == "success"){
        this.staffs = val.data;
        this.generateData();
  		}else{
        this.staffs = [];
        this.generateData();
  			this.toast.presentToast(val.message);
  		}
  	});
  }

  generateData(){
    this.presentStaff = this.staffs.filter(staff => staff.status == 'PRESENT');
    this.absentStaff = this.staffs.filter(staff => staff.status != 'PRESENT');    
  }

  getObject(s : string){
    return JSON.parse(s);
  }

  getRating(s:string){
    if(s && s != "[]"){
      try{
        let obj = JSON.parse(s);
        let num = Math.floor(+obj[0].average_rating);
        return Array(num);
      }catch(err){
        console.log(err);
      }
    }
  }

  getNonRating(s: string){
    let obj = JSON.parse(s);
    let num = Math.floor(+obj[0].average_rating);
    return Array(5-num);
  }

  staffDetail(staff: any){
    this.app.getRootNav().push(StaffDetailPage, {
      parent: this,
      data: staff
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MyStaffPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/my-staff/my-staff.ts